import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * pc探索页面内容依赖的js
 * @exploreService  @exploreService 负责接口api
 * @local_data 一些默认初始化数据
 * @util 工具
 * @boxLeftLink组件
 * @filterBar组件 负责筛选
 * @globalFilterBar 负责全球筛选
 * @liveVideoList 负责列表展示
 * @backTop组件 负责置顶
 */
import exploreService from '@services/exploreService';
import commonService from '@services/commonService';
import { musicHouse, fashionHouse } from '@utils/local_data.js';
import util from '@utils/util';
import boxLeftLink from './boxLeftLink';
import filterBar from './filterBar';
import globalFilterBar from './globalFilterBar';
import liveVideoList from '../../../../basic/live-video-item';
import jieMeitao from './jieMeiTao';
// import backTop from '../../../../basic/back-top';

/**
 * exploreContent 列表页面组合组件
* @boxLeftLink组件
 * @filterBar组件 负责筛选
 * @globalFilterBar 负责全球筛选
 * @liveVideoList 负责列表展示
 * @backTop组件 负责置顶
 */
export default {
  name: 'exploreContent',
  props: {
    serverData: Object
  },
  data: function data() {
    return {
      jmt: false,
      CommonAPIService: null,
      ExploreService: null,
      VideoAPIService: null,
      PersonalAPISerivce: null,
      // 是否现实下载按钮
      showDownload: null,
      // 获取countryCode
      countryCode: 'US',
      list: [],
      cancelTokenSource: null,
      scrollBox: null,
      // 页码
      page_index: 1,
      // 单页请求数量
      page_size: 20,
      // 是否请求中
      run: false,
      // 是否能继续请求列表接口
      showNoData: false,
      showLoadMore: false,
      activedNav: {},
      navkey: '',
      // 初始化 菜单数据
      navs: [{
        key: 'hot',
        title: this.$t('explore.navs.hot'),
        icon: 'hot',
        filters: this.$t('explore.filters.hot')
      }, {
        key: 'global',
        title: this.$t('explore.navs.global'),
        icon: 'global',
        filters: {}
      }, {
        key: 'game',
        title: this.$t('explore.navs.game'),
        icon: 'game',
        filters: this.$t('explore.filters.game')
      }, {
        key: 'star',
        title: this.$t('explore.navs.star'),
        icon: 'star',
        filters: this.$t('explore.filters.star')
      }
      // {
      //     key: 'wonderful',
      //     title: this.$t('explore.navs.wonderful'),
      //     icon: 'wonderful',
      //     filters: this.$t('explore.filters.wonderful')
      // }
      ],
      // navs: [{
      //     key: 'hot',
      //     title: '熱門主播',
      //     icon: 'hot',
      //     filters: {
      //         featured: '熱門',
      //         newcomer: '新人',
      //         girl: '窈窕淑女',
      //         guy: '型男'
      //     }
      // },
      // {
      //     key: 'global',
      //     title: '全球直播',
      //     icon: 'global',
      //     filters: {}
      // },
      // {
      //     key: 'game',
      //     title: '游戏',
      //     icon: 'game',
      //     filters: {
      //         all: '全部'
      //     }
      // },
      // {
      //     key: 'star',
      //     title: '明星',
      //     icon: 'star',
      //     filters: {
      //         official: '官方引導'
      //     }
      // },
      // {
      //     key: 'wonderful',
      //     title: '精彩影音',
      //     icon: 'wonderful',
      //     filters: {
      //         fashionHouse: 'Fashion House'
      //     }
      // }
      // ],
      country_list: [],
      globalFilterTitle: '全球直播'
    };
  },
  components: {
    boxLeftLink: boxLeftLink,
    filterBar: filterBar,
    globalFilterBar: globalFilterBar,
    liveVideoList: liveVideoList,
    jieMeitao: jieMeitao
    // backTop
  },
  methods: {
    isUS: function isUS() {
      return this.countryCode === 'US';
    },
    initShowDownload: function initShowDownload() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var showDownload, language, res, whiteList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              showDownload = false;
              language = window.navigator.language.toLowerCase();
              _context.next = 4;
              return util.getCountryCodeByIp();
            case 4:
              res = _context.sent.toLowerCase();
              if (res === 'cn') {
                whiteList = ['zh-hk', 'zh-tw', 'zh-mo'];
                if (whiteList.includes(language)) {
                  showDownload = true;
                }
              } else {
                showDownload = true;
              }
              _this.showDownload = showDownload;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      this.resetParams();
      this.fetchData();
    },
    resetParams: function resetParams() {
      // 取消上次请求
      this.cancelTokenSource && this.cancelTokenSource.cancel();
      this.list = [];
      this.page_size = 20;
      this.page_index = 1;
      this.run = false;
      this.showNoData = false;
      this.showLoadMore = true;
    },
    getNavFilterKey: function getNavFilterKey() {
      return "".concat(this.activedNav.key, "_").concat(this.activedNav.filterKey || 'all');
    },
    /**
     * 根据switch 根据不同的类型进行数据筛选
     */
    fetchData: function fetchData() {
      var self = this;
      if (self.run) {
        return false;
      }
      // 是否请求中
      self.run = true;
      if (!self.showLoadMore) {
        self.run = false;
        return false;
      }
      var key = self.getNavFilterKey();
      switch (key) {
        case 'hot_featured':
          self.fetchFeatureList();
          break;
        case 'hot_all':
          self.fetchFeatureList();
          break;
        case 'hot_newcomer':
          self.fetchNewcomerList();
          break;
        case 'hot_girl':
          self.fetchGirlList();
          break;
        case 'hot_guy':
          self.fetchBoyList();
          break;
        case 'global_':
          self.fetchGlobalVideoList();
          break;
        case 'global_all':
          self.fetchGlobalVideoList();
          break;
        case 'game_all':
          self.fetchGameList();
          break;
        case 'star_official':
          self.fetchOfficialList();
          break;
        case 'wonderful_musicHouse':
          self.list = musicHouse;
          if (self.list.length === 0) {
            self.showNoData = true;
            self.showLoadMore = false;
          } else {
            self.showLoadMore = false;
          }
          self.run = false;
          break;
        case 'wonderful_fashionHouse':
          self.list = fashionHouse;
          if (self.list.length === 0) {
            self.showNoData = true;
            self.showLoadMore = false;
          } else {
            self.showLoadMore = false;
          }
          self.run = false;
          break;
        default:
          break;
      }
    },
    navClickHandler: function navClickHandler(nav) {
      this.activedNav = nav;
      util.KEWLSensorTrack({
        lmweb_clickText: '探索页分类',
        lmweb_tabName: nav.jmt
      });
      if (nav.key == 'jmt') {
        this.jmt = true;
        return;
      } else {
        this.jmt = false;
      }
      if (this.isUS()) {
        // 此处为了兼容us不展示filter组件
        this.loadData();
      }
    },
    getFilterBarTitle: function getFilterBarTitle() {
      return this.activedNav.title;
    },
    getFilters: function getFilters() {
      return this.activedNav.filters;
    },
    filterSelectHandler: function filterSelectHandler(filterKey) {
      this.activedNav.filterKey = filterKey;
      this.loadData();
    },
    globalFilterSelectHandler: function globalFilterSelectHandler(inter, country) {
      this.activedNav.filterKey = '';
      this.activedNav.country_code = country.country_code;
      this.globalFilterTitle = country.country_code === 'GLOBAL' ? this.activedNav.title : country.country_name;
      this.loadData();
    },
    loadMoreClickHandler: function loadMoreClickHandler() {
      this.fetchData();
    },
    // 热门
    fetchFeatureList: function fetchFeatureList() {
      var self = this;
      self.fetchList('getFeaturelist', self.countryCode, self.page_index, self.page_size, '');
    },
    // 新人  还没有解决
    fetchNewcomerList: function fetchNewcomerList() {
      var self = this;
      self.fetchList('homepageNew', self.countryCode, self.page_index, self.page_size, '');
    },
    // 美女
    fetchGirlList: function fetchGirlList() {
      var self = this;
      self.fetchList('getGirlData', self.countryCode, self.page_index, self.page_size, '');
    },
    // 帅哥
    fetchBoyList: function fetchBoyList() {
      var self = this;
      self.fetchList('getBoyData', self.countryCode, self.page_index, self.page_size, '');
    },
    fetchGlobalVideoList: function fetchGlobalVideoList() {
      this.fetchList('getVideoList', this.activedNav.country_code, this.page_index, this.page_size, '');
    },
    // 官方直播
    fetchOfficialList: function fetchOfficialList() {
      var _this2 = this;
      this.fetchList('getNewWebList', this.countryCode, '', '', function () {
        // 首页接口不支持分页，所以直接隐藏loadmore
        _this2.showLoadMore = false;
      });
    },
    // 游戏
    fetchGameList: function fetchGameList() {
      this.fetchList('getGameList', this.countryCode, this.page_index, this.page_size, '');
    },
    fetchList: function fetchList(method, cCode, page, pageSize, afterCb) {
      var _this3 = this;
      switch (method) {
        case 'getNewWebList':
          this.ExploreService.getNewWebList(cCode).then(function (res) {
            _this3.getRes(res, afterCb);
          }).catch(function (err) {
            console.error('getNewWebList', err);
            _this3.run = false;
          });
          break;
        case 'homepageNew':
          this.ExploreService.homepageNew(page, cCode).then(function (res) {
            _this3.getRes(res, afterCb);
          }).catch(function (err) {
            console.error('homepageNew', err);
            _this3.run = false;
          });
          break;
        case 'getFeaturelist':
          if (util.isJMT(cCode)) {
            this.ExploreService.getRecentlyVideo('CN', page, pageSize).then(function (res) {
              _this3.getRes(res, afterCb);
            }).catch(function () {
              _this3.run = false;
            });
          } else {
            this.ExploreService.getFeaturelist(cCode, page, pageSize).then(function (res) {
              _this3.getRes(res, afterCb);
            }).catch(function () {
              _this3.run = false;
            });
          }
          break;
        case 'getVideoList':
          this.ExploreService.getVideoList(cCode, page, pageSize).then(function (res) {
            _this3.getRes(res, afterCb);
          }).catch(function () {
            _this3.run = false;
          });
          break;
        case 'getBoyData':
          this.ExploreService.getBoyData(cCode, page, pageSize).then(function (res) {
            _this3.getRes(res, afterCb);
          }).catch(function () {
            _this3.run = false;
          });
          break;
        case 'getGirlData':
          this.ExploreService.getGirlData(cCode, page, pageSize).then(function (res) {
            _this3.getRes(res, afterCb);
          }).catch(function () {
            _this3.run = false;
          });
          break;
        case 'getGameList':
          this.ExploreService.getGameList(cCode, page, pageSize).then(function (res) {
            _this3.getRes(res, afterCb);
          }).catch(function () {
            _this3.run = false;
          });
          break;
        default:
          break;
      }
    },
    getRes: function getRes(res, afterCb) {
      var _this4 = this;
      // 如果返回内容长度 小于// 单页请求数量
      var list = res.video_info || res.video_list || res.viewpager_list || [];
      if (this.page_index === 1) {
        this.list = list;
      } else if (Array.isArray(list)) {
        this.list = this.list.concat(list);
      }
      this.$nextTick(function () {
        // DOM 更新了
        // 是否请求中
        _this4.run = false;
        if (_this4.list.length === 0) {
          _this4.showNoData = true;
          _this4.showLoadMore = false;
        } else if (list.length == 0) {
          // 是否能继续请求列表接口
          _this4.showLoadMore = false;
        } else {
          // eslint-disable-next-line no-plusplus
          _this4.page_index++;
          _this4.showLoadMore = true;
        }
        afterCb && afterCb !== '' && afterCb();
      });
    },
    // 国家数据 – 区分大洲
    fetchInterCountryList: function fetchInterCountryList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var self, data, global, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              self = _this5;
              _context2.next = 3;
              return _this5.CommonAPIService.getInterCountryList(util.getI18nLocale(), _this5.countryCode);
            case 3:
              data = _context2.sent;
              if (data) {
                // 将全球移动到第一位
                global = null;
                res = data.country_list.filter(function (item) {
                  if (item.inter_id !== '6') {
                    return true;
                  } else {
                    global = item;
                    return false;
                  }
                });
                if (global) {
                  res.unshift(global);
                }
                self.country_list = res;
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    scrollHandler: function scrollHandler() {
      if (this.$refs.scrollBox.scrollHeight && this.$refs.scrollBox.scrollTop) {
        if (this.$refs.scrollBox.scrollHeight - (this.$refs.scrollBox.clientHeight + parseInt(this.$refs.scrollBox.scrollTop)) <= 70) {
          this.fetchData();
        }
      }
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this6.initShowDownload();
            _context3.next = 3;
            return util.getI18nCountryCode(_this6.$route.params.countryCode);
          case 3:
            _this6.countryCode = _context3.sent.toUpperCase();
            if (_this6.isUS()) {
              _this6.navs = [{
                key: 'hot',
                title: _this6.$t('explore.navs.hot'),
                icon: 'hot',
                filters: {}
              }, {
                key: 'game',
                title: _this6.$t('explore.navs.game'),
                icon: 'game',
                filters: {}
              }];
            }
            // 如果是台湾加入姐妹淘
            if (util.isTW(_this6.countryCode)) {
              _this6.navs.push({
                key: 'jmt',
                title: '熱門活動',
                icon: 'hot',
                filters: {
                  all: '全部'
                }
              });
            }
            // 初始化 Api
            _this6.CommonAPIService = commonService.createApi();
            _this6.ExploreService = exploreService.createApi();
            _this6.navkey = _this6.$route && _this6.$route.query.navkey ? _this6.$route.query.navkey : 'hot';
            res = _this6.navs.filter(function (item) {
              return item.key === _this6.navkey;
            });
            _this6.activedNav = res.length > 0 ? res[0] : _this6.navs[0];
            if (!_this6.isUS()) {
              _this6.fetchInterCountryList();
            } else {
              _this6.activedNav.filterKey = 'all';
              _this6.loadData();
            }
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  mounted: function mounted() {
    this.scrollBox = this.$refs.scrollBox;
    this.$refs.scrollBox.addEventListener('scroll', this.scrollHandler);
  }
};